import axios from 'axios';

export default {
    setInterceptors: () => {
        axios.interceptors.response.use(
            (response) => {
                localStorage.removeItem("error_throw");
                return response;
            },
            (error) => {
                const errorResponse = error.response;

                if (errorResponse?.data?.message?.otp) {
                    return Promise.reject(error);
                }

                if (errorResponse?.status === 404 || errorResponse?.status === 500) {
                    localStorage.setItem("error_throw", "yes");
                }

                return Promise.reject(error);
            }
        );
    }
}